import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators } from "@angular/forms";
import {Router} from "@angular/router";
import { BehaviorSubject, throwError } from 'rxjs';
import { AutologoutService } from 'src/app/service/autologout.service';
import {ApiService} from "../../service/api.service"
import { AuthService } from "../../service/auth.service";
import { NotificationService } from '../../service/notification.service';
import { ConfirmedValidator } from '../../validators/confirmed.validator';
import { AuthorizationCheckService } from 'src/app/service/authorization-check.service';

declare var jQuery: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit,OnDestroy  {
  @Input() selectedModule: any;

  private loggedIn = new BehaviorSubject<boolean>(false);
  private token: string;
  public loader: boolean=false;
  public showOtp:boolean=false;
  public showOtpforgotpw:boolean=false;
  public isOTPsend:boolean=false;
  public isVerified:boolean=false;
  public generatebtnforgotPwd:boolean=true;
  public generatebtn:boolean=true;
  public verifybtn:boolean=false;
  public verifybtnforgotPWd:boolean=false;
  public isResendOtp: boolean=false;
  public showPasswdbox: boolean=false;
  public submitbtnforgotPWd: boolean=false;

  GlinkList: any[] = [];
 
@ViewChild('modalLogin', { static: false }) modalLogin: ElementRef;

  loginForm: FormGroup;
  loginFormMobile: FormGroup;
  loginErrorData: string;
  loginSuccessData: string;
  forgotpasswordForm: FormGroup;
  code: number;
  captcha: string;
  private captchaAnswer: string = '';


  constructor(
    private formBuilder: FormBuilder,
    private notifyService:NotificationService, 
    private router: Router,
    private autologout:AutologoutService, 
    private apiService: ApiService,
    private authService: AuthService,
    private authorizationCheckService: AuthorizationCheckService
  ) {
     const userData = sessionStorage.getItem('user');
     if (userData) {
       const user = JSON.parse(userData);
       this.token = user.token;
       this.apiService.setLoggedIn(true, this.token);
       this.loggedIn.next(true);
     }
   }

  ngOnInit(): void {
   this.loader=false;
  this.loginForm = this.formBuilder.group({
     login_id: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9._-]{4,20}')]],
     password: ['', Validators.compose([Validators.required,Validators.minLength(8)])],
     captchaValue:['']
  });
  // this.loginForm = this.formBuilder.group({
 //   login_id: ['', Validators.compose([Validators.required])],
  //  password: ['', Validators.required],
 //   captchaValue:['']
  //});
  this.loginFormMobile = this.formBuilder.group({
    mobileno:  ['',Validators.compose([Validators.required,Validators.pattern("[0-9 ]{10}")])],
    otp:  ['',Validators.compose([Validators.required,Validators.pattern("[0-9 ]{6}")])]
  });
  this.forgotpasswordForm = this.formBuilder.group({
    mobilenumber:  ['',Validators.compose([Validators.required,Validators.pattern("[0-9 ]{10}")])],
    otpforgot:  ['',Validators.compose([Validators.required,Validators.pattern("[0-9 ]{6}")])],
    password: ['',Validators.compose([Validators.required,Validators.minLength(8)])],
    cpassword: ['', Validators.required]
  }, {
    validator: ConfirmedValidator('password', 'cpassword')
  });

  var ds=this;
    (function($){

      $('#modalPassword').off('shown.bs.modal').on('shown.bs.modal', function () {
        ds.loader=false;
        ds.showOtpforgotpw=false;
       ds.isOTPsend=false;
       ds.isVerified=false;
       ds.generatebtnforgotPwd=true;
       ds.generatebtn=true;
       ds.verifybtn=false;
       ds.verifybtnforgotPWd=false;
       ds.showPasswdbox=false;
       ds.isResendOtp=false;
       ds.submitbtnforgotPWd=false;
       ds.forgotpasswordForm.reset();
       ds.forgotpasswordForm.controls.mobilenumber.enable();
       ds.forgotpasswordForm.controls.otpforgot.enable();
     });
     $('#modalLogin').off("shown.bs.modal").on('shown.bs.modal', function (e) {
      ds.loader=false;
      ds.showOtpforgotpw=false;
     ds.isOTPsend=false;
     ds.isVerified=false;
     ds.generatebtnforgotPwd=true;
     ds.generatebtn=true;
     ds.verifybtn=false;
     ds.verifybtnforgotPWd=false;
     ds.isResendOtp=false;
     ds.submitbtnforgotPWd=false;
     ds.forgotpasswordForm.controls.mobilenumber.enable();
     ds.forgotpasswordForm.controls.otpforgot.enable();
     ds.forgotpasswordForm.reset();
     window.sessionStorage.removeItem('code');
      
     // Create captcha with a small delay to ensure DOM is ready
    //  setTimeout(() => {
    //    ds.refreshCaptcha();
    //  }, 150);
     
     e.preventDefault();
   });
   
   // Also create captcha when modal is opened (not just shown)
  //  $('#modalLogin').off("show.bs.modal").on('show.bs.modal', function (e) {
  //    // Ensure captcha is created even if shown event doesn't fire
  //    setTimeout(() => {
  //      if (!document.getElementById('captchaCanvas')) {
  //        ds.refreshCaptcha();
  //      }
  //    }, 100);
  //  });

   $("#closeBtn").on('click', function(event : any) {

     window.sessionStorage.removeItem('code');
    //window.sessionStorage.removeItem('code');
     ds.loader=false;
   });

    $("#show_hide_password a").on('click', function(event : any) {
        event.preventDefault();
        if($('#show_hide_password input').attr("type") == "text"){
            $('#show_hide_password input').attr('type', 'password');
            $('#show_hide_password i').addClass( "fa-eye-slash" );
            $('#show_hide_password i').removeClass( "fa-eye" );
        }else if($('#show_hide_password input').attr("type") == "password"){
            $('#show_hide_password input').attr('type', 'text');
            $('#show_hide_password i').removeClass( "fa-eye-slash" );
            $('#show_hide_password i').addClass( "fa-eye" );
        }
    });


    })(jQuery);

    window.sessionStorage.removeItem('token');
    window.sessionStorage.removeItem("username");
    window.sessionStorage.removeItem("user_type");
  }
    ngOnDestroy() {
    if (this.modalLogin) {
      $(this.modalLogin.nativeElement).off('shown.bs.modal');
    }
  }
    ngAfterViewInit() {
    // Regenerate captcha only when modal is shown
    if (this.modalLogin) {
      $(this.modalLogin.nativeElement).off('shown.bs.modal').on('shown.bs.modal', () => {
       
          this.refreshCaptcha();
          this.loginForm.reset(); 
      
      });
    }
  }
  async onSubmit() {
    const enteredCaptcha = this.loginForm.value.captchaValue;
    //const storedCaptcha=(sessionStorage.getItem('code'));

    if (!enteredCaptcha || enteredCaptcha !== this.captchaAnswer) {
      this.notifyService.showError("Invalid Captcha. try Again", "Error");
      this.refreshCaptcha(); // regenerate after invalid attempt
      return;
    }
  
    if (this.loginForm.value.captchaValue== this.captchaAnswer) {
      this.loginErrorData = "";
     this.loader=true;
      if (this.loginForm.valid)
      {
          try {
                 await this.authService.login(this.loginForm.value).subscribe(
                  {
                    next : (response: any) => {
                        // console.log(response);
                      if(response!==undefined){
                       if(response.roleId==4 || response.roleId==7 || response.roleId==8 || response.roleId==9 ){
                          this.notifyService.showError("You are not authorized to access Web portal.Please contact admin.","Error");
                          this.loader=false;
                          window.sessionStorage.removeItem('token');
                          window.sessionStorage.removeItem("username");
                          window.sessionStorage.removeItem("user_type");
                          delete this.token;
                          this.loggedIn.next(false);
                          sessionStorage.clear();
                          return;
                       }
                      if (response.username!==undefined  && response.accessToken !== undefined) {
                          this.token = response.accessToken;
                          this.apiService.setLoggedIn(true, this.token);
                          this.loggedIn.next(true);
                          const userData = {
                            userid:response.id,
                            username:response.username,
                            email:response.email,
                            roles:response.roles,
                            roleId:response.roleId,
                            juridictionId:response.juridictionId,
                            circleId:response.circleId,
                            divisionId: response.divisionId,
                            rangeId:response.rangeId,
                            sectionId:response.sectionId,
                            beatId: response.beatId,
                            token: this.token,
                            seqNo:response.seqNo
                          };

                          sessionStorage.setItem('user', JSON.stringify(userData));
                          sessionStorage.setItem('token', this.token);
                          this.autologout.setLastAction(Date.now());
                          window.sessionStorage.removeItem('code');
                          //window.location.href = 'dashboard';
                          // if(userData.roleId==10 || userData.roleId==11 || userData.roleId==12)
                          //   {
                          //     this.router.navigate(['apo-report']);
                          //   }
                          //   else{
                          //     this.router.navigate(['dashboard']);
                          //   }
                          this.handleLoginSuccess(userData.roleId);
                        }else   if (response.message=="invalidUser"){
                          this.notifyService.showError("Please check whether your username and password are correct.","Error");
                          this.loader=false;
                          window.sessionStorage.removeItem('token');
                          window.sessionStorage.removeItem("username");
                          window.sessionStorage.removeItem("user_type");
                          delete this.token;
                          this.loggedIn.next(false);
                          sessionStorage.clear();
                        }
                      }
                    },
                    error :(error) => {
                      const errors = error;
                      this.loader=false;
                      //console.log(errors);
                     // this.notifyService.showError("Please check whether your username and password are correct.","");
                      //return throwError(errors);
                    }
                  });
              }catch (err) {
                const errors = err;
                this.loader=false;
                //console.log(errors)
                return throwError(errors);
              }
      } else {
        this.notifyService.showError("Login Failed","Error");
        this.loginErrorData =  "User not active.";
        this.loader=false;
        return;
      }
      setTimeout(() => {
        this.loginErrorData = "";
      }, 5000);
    }else{
      this.notifyService.showError("Invalid Captcha. try Again","Error");
      //alert("Invalid Captcha. try Again");
      this.loginForm.controls.captchaValue.setValue("");
      this.refreshCaptcha();
    }
  }
  closebtnClick(){
    sessionStorage.removeItem('code');
    //window.sessionStorage.removeItem('code');
    this.loader=false;
  }
   refreshCaptcha() {
  try {
    //sessionStorage.removeItem('code');

    const captchaElement = document.getElementById('captcha');
     if (!captchaElement) {
      console.error('Captcha element not found');
      return;
    }
    captchaElement.innerHTML = ""; // Clear immediately

    // Generate captcha numbers
    let x = Math.floor(Math.random() * 10 + 1);
    let y = Math.floor(Math.random() * 10 + 1);
    let captcha = `${x} + ${y} =`;

    // Canvas creation
    let canv = document.createElement("canvas");
    canv.id = "captchaCanvas";
    canv.width = 100;
    canv.height = 50;

    let ctx = canv.getContext("2d");
    ctx.fillStyle = "#f0f0f0";
    ctx.fillRect(0, 0, canv.width, canv.height);
    ctx.font = "20px Arial";
    ctx.fillStyle = "#333";
    ctx.textAlign = "center";
    ctx.fillText(captcha, canv.width / 2, 30);

    captchaElement.appendChild(canv);

    // Store answer once clearly
    let z = x + y;
     this.captchaAnswer=(x + y).toString();;
    //sessionStorage.setItem('code', z.toString());

    // Clear user's captcha input immediately
    this.loginForm.controls.captchaValue.setValue('');


  } catch (error) {
    console.error('Error generating captcha:', error);
  }
}
  // createCaptcha() {

  //   //console.log("1")
  //   //clear the contents of captcha div first
  //   document.getElementById('captcha').innerHTML = "";
  //   var charsArray =
  //   "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
  //   var lengthOtp = 6;
  //   var captcha = [];
  //   for (var i = 0; i < lengthOtp; i++) {
  //     //below code will not allow Repetition of Characters
  //     var index = Math.floor(Math.random() * charsArray.length + 1); //get the next character from the array
  //     if (captcha.indexOf(charsArray[index]) == -1)
  //       captcha.push(charsArray[index]);
  //     else i--;
  //   }
  //   var canv = document.createElement("canvas");
  //   canv.id = "captcha";
  //   canv.width = 100;
  //   canv.height = 50;
  //   var ctx = canv.getContext("2d");
  //   ctx.font = "25px Georgia";
  //   ctx.strokeText(captcha.join(""), 0, 30);
  //   //storing captcha so that can validate you can save it somewhere else according to your specific requirements
  //   this.code = captcha.join("");
  //   document.getElementById("captcha").appendChild(canv); // adds the canvas to the body element
  // }
  generateotp(){
    try{
      let mobile=this.loginFormMobile.value.mobileno;
      if (mobile !== '') {
         this.apiService.request('POST', 'api/v1/auth/generateotp?mobileNumber='+mobile).subscribe((response: any) => {
      //console.log(response.message);
          if(response.message=="success"){
            this.showOtp=true;
            this.generatebtn=false;
            this.verifybtn=true;
            this.notifyService.showSuccess("OTP generated successfully","Success");
            this.loginErrorData =  "";
            this.loginSuccessData="Success : OTP generated successfully";

          }else if(response.message=="notValid"){
            this.notifyService.showError("Mobile Number is not registered","Error");
            this.showOtp=false;
            this.generatebtn=true;
            this.verifybtn=false;

            this.loginErrorData = "Error : Mobile Number is not registered";
            this.loginSuccessData="";
          }
        },(error) => {
            const errors = error;
            //console.log(errors);
            return throwError(errors);
          });
        }else{
          this.notifyService.showError("Mobile Number is required","Error");
          this.loginErrorData =  "Error : Mobile Number is required";
          this.loginSuccessData="";
        }
      }catch(err){
        this.showOtp=false;
        this.generatebtn=true;
        this.verifybtn=false;
      }
  }
  loginWithOtp(){
    try{
      this.loader=true;
      let mobile=this.loginFormMobile.value.mobileno;
      let otp=this.loginFormMobile.value.otp;
      if(mobile!=""){
        if(otp!=""){
          return this.apiService.request('POST', 'api/v1/auth/otpBasedLogin', {
            login_id: mobile,
            password: otp
          }).subscribe((response: any) => {
            if (response.username!==undefined  && response.accessToken !== undefined) {
              this.token = response.accessToken;
              this.apiService.setLoggedIn(true, this.token);
              this.loggedIn.next(true);
              const userData = {
                userid:response.id,
                username:response.username,
                email:response.email,
                roles:response.roles,
                roleId:response.roleId,
                juridictionId:response.juridictionId,
                circleId:response.circleId,
                divisionId: response.divisionId,
                rangeId:response.rangeId,
                sectionId:response.sectionId,
                beatId: response.beatId,
                token: this.token,
                seqNo:response.seqNo
              };
              sessionStorage.setItem('user', JSON.stringify(userData));
              sessionStorage.setItem('token', this.token);
              //window.location.href = 'dashboard';
              this.router.navigate(['dashboard']);
            }else if(response.message=="invalidOtp"){
              this.notifyService.showError("Invalid OTP","Error");
              this.loginErrorData = "Error : Invalid OTP";
              this.loginSuccessData="";
              this.loader=false;
            }else if(response.message=="invalidMobile"){
              this.notifyService.showError("Invalid Mobile Number","Error");
              this.loginErrorData = "Error : Invalid Mobile Number";
              this.loginSuccessData="";
              this.loader=false;
            }
          }
          ,(error) => {
              const errors = error;
              //console.log(errors);
              return throwError(errors);
          }
          );
        }else{
          this.notifyService.showError("Please enter OTP ","Error");
          this.loader=false;
        }
      }else{
        this.notifyService.showError("Please enter Mobile Number ","Error");
        this.loader=false;
      }
    }catch(err){
      this.loader=false;
    }

  }

// forgotpassword

  generateotpforgotPwd(){
    try{
      if(this.isResendOtp==true){
        this.forgotpasswordForm.controls.otpforgot.setValue('');
      }
      this.loader=true;
      let mobile=this.forgotpasswordForm.value.mobilenumber;
      if (mobile !== '') {
         this.apiService.request('POST', 'api/v1/auth/generateotp?mobileNumber='+mobile).subscribe((response: any) => {
      //console.log(response.message);
          if(response.message=="success"){
           // this.forgotpasswordForm.controls.mobileno.disable();
            this.showOtpforgotpw=true;
            this.generatebtnforgotPwd=false;
            this.verifybtnforgotPWd=true;
            this.isResendOtp=true;
            this.isOTPsend=true;
            this.notifyService.showSuccess("OTP generated successfully","Success");
            this.loginErrorData =  "";
            this.loginSuccessData="Success : OTP generated successfully";
            this.loader=false;

          }else if(response.message=="notValid"){
            this.notifyService.showError("Mobile Number is not registered","Error");
            this.showOtpforgotpw=false;
            this.generatebtnforgotPwd=true;
            this.verifybtnforgotPWd=false;
            this.isOTPsend=false;
            this.loginErrorData = "Error : Mobile Number is not registered";
            this.loginSuccessData="";
            this.loader=false;
          }
        },(error) => {
            const errors = error;
            //console.log(errors);
            return throwError(errors);
          });
        }else{
          this.notifyService.showError("Mobile Number is required","Error");
          this.loginErrorData =  "Error : Mobile Number is required";
          this.loginSuccessData="";
          this.loader=false;
        }
      }catch(err){
        this.loader=false;
        this.showOtpforgotpw=false;
        this.generatebtnforgotPwd=true;
        this.verifybtnforgotPWd=false;
      }
  }
  verifyOtp(){
    try{
      this.loader=true;
      let mobile=this.forgotpasswordForm.value.mobilenumber;
      let otp=this.forgotpasswordForm.value.otpforgot;
      if(mobile!=""){
        if(otp!=""){
          return this.apiService.request('POST', 'api/v1/auth/otpVerified', {
            login_id: mobile,
            password: otp
          }).subscribe((response: any) => {
            //console.log(response);
            if (response.message=="verified") {
              this.forgotpasswordForm.controls.mobilenumber.disable();
              this.forgotpasswordForm.controls.otpforgot.disable();
              this.showOtpforgotpw=true;
              this.generatebtnforgotPwd=false;
              this.verifybtnforgotPWd=false;
              this.isResendOtp=false;
              this.isOTPsend=false;
              this.isVerified=true;
              this.showPasswdbox=true;
              this.submitbtnforgotPWd=true;
              this.notifyService.showSuccess("OTP Verified successfully","Success");
              this.loginErrorData =  "";
              this.loginSuccessData="Success : OTP Verified successfully";
              this.loader=false;
            }else if(response.message=="invalidOtp"){
              this.notifyService.showError("Invalid OTP","Error");
              this.loginErrorData = "Error : Invalid OTP";
              this.loginSuccessData="";
              this.loader=false;
            }else if(response.message=="invalidMobile"){
              this.notifyService.showError("Invalid Mobile Number","Error");
              this.loginErrorData = "Error : Invalid Mobile Number";
              this.loginSuccessData="";
              this.loader=false;
            }
          }
          ,(error) => {
              const errors = error;
              //console.log(errors);
              return throwError(errors);
          }
          );
        }else{
          this.notifyService.showError("Please enter OTP ","Error");
          this.loader=false;
        }
      }else{
        this.notifyService.showError("Please enter Mobile Number ","Error");
        this.loader=false;
      }
    }catch(err){
      this.loader=false;
    }
  }
  resetPwdwithOtp(value:any){
    try{
      this.loader=true;
      let mobile=this.forgotpasswordForm.value.mobilenumber;
      let pwd=value.password;
      //console.log(this.mobno)
      if(mobile!=""){
        if(pwd!=""){
          return this.apiService.request('PUT', 'api/v1/auth/resetPasswordWithMobile?mobile='+mobile+'&newPassword='+pwd).subscribe((res: any) => {
            //console.log(res);
            var response = JSON.parse(res);
            if (response.message=="Success") {
             this.loader=false;
             this.showOtpforgotpw=false;
            this.isOTPsend=false;
            this.isVerified=false;
            this.generatebtnforgotPwd=true;
            this.generatebtn=true;
            this.verifybtn=false;
            this.verifybtnforgotPWd=false;
            this.showPasswdbox=false;
            this.isResendOtp=false;
            this.submitbtnforgotPWd=false;
            this.forgotpasswordForm.reset();
            this.forgotpasswordForm.controls.mobilenumber.enable();
            this.forgotpasswordForm.controls.otpforgot.enable();
              this.notifyService.showSuccess("Password Changed successfully","Success");
              this.loginErrorData =  "";
              this.loginSuccessData="Success : Password Changed successfully";
              this.loader=false;
            }else if(response.message=="failed"){
              this.notifyService.showError("Error","Error");
              this.loginErrorData = "Error";
              this.loginSuccessData="";
              this.loader=false;
            }else if(response.message=="invalidMobile"){
              this.notifyService.showError("Invalid Mobile Number","Error");
              this.loginErrorData = "Error : Invalid Mobile Number";
              this.loginSuccessData="";
              this.loader=false;
            }
          }
          ,(error) => {
              const errors = error;
              //console.log(errors);
              return throwError(errors);
          }
          );
        }else{
          this.notifyService.showError("Please enter Password ","Error");
          this.loader=false;
        }
      }else{
        this.notifyService.showError("Please enter Mobile Number ","Error");
        this.loader=false;
      }
    }catch(err){
      this.loader=false;
    }
  }



handleLoginSuccess(roleId:any){
     this.apiService.request('GET', 'api/v1/link/getAllGlinkByRoleId?roleId='+roleId).subscribe((data: Array<any>) => {
          if (data.length>0) {
           // console.log(data)
            
            this.GlinkList = new Array() ;
            var validUrl=new Array();
            data.map(item=>{
              return {
                glink_id : item['glink_id'],
                globalSeq: item['globalSeq'],
                isActive: (item['isActive'] == null) ? (this.checkplink(item['pLInk']) == true ? true : false ): (item['glink_id']==10?true:item['isActive'] ),
                linkName: item['linkName'],
                gIcon: item['gIcon'],
                name: item['name'],
                pLInk:item['pLInk'] == null ? [] : item['pLInk']
              }
            }).forEach(item=> this.GlinkList.push(item));
            // Collect all valid child links (pLInk) first
            this.GlinkList.forEach(element => {
              if (element.pLInk && element.pLInk.length > 0) {
                element.pLInk.forEach(link => {
                  if (link.isActive === 'true' && link.linkName) {
                    validUrl.push({ linkName: link.linkName });
                  }
                });
              } else if ((element.isActive === true || element.isActive === 'true') && element.linkName) {
                validUrl.push({ linkName: element.linkName });
              }
            });
            sessionStorage.setItem('link', JSON.stringify(this.GlinkList));
            //  console.log(this.GlinkList)

            // Set allowed links for the guard
             this.authorizationCheckService.setAllowedLinks(this.GlinkList);
             //******************Landing Dashboard********************************* */
          //   const allowedRoutes: string[] = [];
          //   (this.GlinkList || []).forEach(item => {
          //     if (item.isActive === true || item.isActive === 'true') {
          //     if (item.linkName) allowedRoutes.push(item.linkName.replace(/^\//, ''));
          //     if (item.pLInk && Array.isArray(item.pLInk)) {
          //       item.pLInk.forEach(link => {
          //         if (link.isActive === true || link.isActive === 'true') {
          //         if (link.linkName) allowedRoutes.push(link.linkName.replace(/^\//, ''));
          //         }
          //       });
          //     }
          //    }
          //   }); 


          //  // console.log("allowedRoutes",allowedRoutes)
          //  // console.log("this.selectedModule.route",this.selectedModule.route)
          //          // Route access check
          // if (
          //   this.selectedModule.route &&
          //   allowedRoutes.includes(this.selectedModule.route)
          // ) {
          //   this.router.navigate([this.selectedModule.route]);
          //         this.loader=false;
          //   ($('#modalLogin') as any).modal('hide');
          // } else {
          //   this.notifyService.showError(
          //     'You are not authorized to access this module.',
          //     'Unauthorized'
          //   );
          //   localStorage.clear();
          //     sessionStorage.clear();
          //     this.router.navigate(['/']);
          //         this.loader=false;
          //   ($('#modalLogin') as any).modal('hide');
          //   return;
          // }
          // this.loader=false;
            //************************************************ */
            // Redirect to the first valid URL if available
            if(validUrl.length > 0 && validUrl[0].linkName){
              // Remove leading slash if present
              const route = validUrl[0].linkName.startsWith('/') ? validUrl[0].linkName.substring(1) : validUrl[0].linkName;
              this.router.navigate([route]);
              return;
            }
          }else{
            this.notifyService.showError("No valid menu found","Error");
          //  console.log('No valid menu found');
            this.loader=false;
          }
          // // Fallback if no validUrl found
          // if(roleId==10 || roleId==11 || roleId==12)
          // {
          //   this.router.navigate(['apo-report']);
          // }
          // else if(roleId==13)
          // {
          //   this.router.navigate(['apo-list']);
          // }else{
          //   this.router.navigate(['not-found']);
          // }
        });
 }
  checkplink(item : Array<any>)
   {
     var returnstmnt ;
     var count = 0;
    for (let index = 0; index < item.length; index++) {
      const element = item[index];
      if(element.isActive == "true")
      {
        count = count+ 1 ;
      }
    }
     if(count > 0 )
     {
       returnstmnt = true;
     }
     else
     {
       returnstmnt = false;
     }
    return returnstmnt ;
   }
   validateUrl(data:any[]) {
    let count=0;
    var url = this.router.url.split('/');
    for (var i = 0; i < data.length; i++) {
      if (data[i]["linkName"].replace('/', '').trim() === url[1]) {
        count++
      }
    }
    if(url[1]=="profile" || url[1]=="changepassword")
    {
      count++
    }
    if (count == 0) {
      this.notifyService.showError("Unauthorized","Error");
      this.router.navigateByUrl('/dashboard');


     //this.router.navigate(['dashboard'])
      //sessionStorage.clear();
      //this.router.navigate(['/']);
    //  this.loader = false;
    }
   // this.loader = false;
  }
}
